// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__xi2KS","ranges":"BmiRanges_ranges__3vvPm"};